import { Topics } from './topics';

/**
 * @deprecated Use IQuery instead.
 */
export abstract class IUntypedQuery {
    public static readonly TOPIC: Topics;
}

/**
 * Use in conjuction with IQueryHandler.
 */
export abstract class IQuery<ReturnType> {
    public static readonly TOPIC: Topics;

    /**
     * Will never be assigned or used as a value.
     * Only used to infer the return type of the query.
     * @internal
     */
    readonly returnType?: ReturnType;
}

// Helper type to extract return type excluding undefined but preserving null
type QueryResult<T extends IQuery<any>> = T extends IQuery<infer R> ? R : never;

/**
 * Enforces return types of handler to correspond with that of the query.
 */
export interface IQueryHandler<T extends IQuery<any>> {
    handle(q: T): Promise<QueryResult<T>>;
}
